import { ServerFetch } from '../main-model'

export default class InvoiceCustomerCostModel extends ServerFetch {
    getInvoiceCustomerCostBy = (data) => this.authFetch({
        url: 'invoice-customer-cost/getInvoiceCustomerCostBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}